module.exports = __webpack_public_path__ + "files/a75672313af456c21db5a1d41ef7aa66.png";